import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SavedSearchesCardContainerComponent } from './saved-searches-card-container.component';
import { SavedSearchesCardComponent } from './components/saved-searches-card.component';
import {  MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule, RouterLink],
  declarations: [SavedSearchesCardComponent, SavedSearchesCardContainerComponent],
  exports: [SavedSearchesCardContainerComponent],
})
export class SavedSearchesCardModule {}
